import React from "react";

import { NormalizedPrediction } from "../types";
import { GameCard } from "./GameCard";

interface GameGridProps {
  predictions: NormalizedPrediction[];
}

/**
 * Renders the grid of GameCards.
 * Computes which game is the "Top Pick" (highest confidence) and passes
 * a stagger index to each card for entrance animation.
 */
export function GameGrid({ predictions }: GameGridProps): JSX.Element {
  // Determine the top pick — highest finalConfidence game
  const topPickId = React.useMemo(() => {
    if (predictions.length === 0) return null;
    let best: NormalizedPrediction | null = null;
    for (const p of predictions) {
      if (p.finalConfidence != null && (best === null || (best.finalConfidence ?? 0) < p.finalConfidence)) {
        best = p;
      }
    }
    return best?.gameId ?? null;
  }, [predictions]);

  return (
    <div className="game-grid-wrap">
      <div className="game-grid" role="list" aria-label="Game predictions">
        {predictions.map((prediction, index) => (
          <div
            role="listitem"
            key={prediction.gameId}
            className="game-card-entrance"
            style={{ animationDelay: `${index * 60}ms` }}
          >
            <GameCard
              prediction={prediction}
              isTopPick={prediction.gameId === topPickId}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
